export enum UnitMode {
  Metric = "Metric",
  Imperial = "Imperial",
}

const MAP = {
  [UnitMode.Metric]: UnitMode.Metric,
  [UnitMode.Imperial]: UnitMode.Imperial,
};

export function getUnitModeFromString(val: string | undefined): UnitMode | undefined {
  return MAP[val?.toLowerCase() ?? ""] ?? undefined;
}
